// extracted by mini-css-extract-plugin
export default {"container":"AuthPage_container__zjPH4","form":"AuthPage_form__dBXpo"};